/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import { EmitterMixin } from 'ckeditor5/src/utils.js';

import MessagesCompressor from './../messagescompressor';
import { IWebSocketGateway, WEB_SOCKET_GATEWAY_STATES } from '../websocketgateway/websocketgateway';

import IsEditorBundleUploadedMessage from './messages/iseditorbundleuploadedmessage';
import IsEditorBundleUploadedResponse from './responses/iseditorbundleuploadedresponse';
import CKEditorCloudServicesError from '../ckeditorcloudserviceserror';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const _SERVICE: number = 13;

// eslint-disable-next-line new-cap
class EditorService extends /* #__PURE__ -- @preserve */ EmitterMixin() {
	private static readonly _SERVICE: number = _SERVICE;

	public static async isBundleUploaded( wsGateway: IWebSocketGateway, bundleVersion: string ): Promise<boolean> {
		const message: IsEditorBundleUploadedMessage = new IsEditorBundleUploadedMessage( bundleVersion );

		if ( wsGateway.state !== WEB_SOCKET_GATEWAY_STATES.CONNECTED ) {
			throw new CKEditorCloudServicesError( 'WebSocket Gateway is not connected.', wsGateway );
		}

		const response: Buffer = await wsGateway._sendRequest(
			EditorService._SERVICE,
			IsEditorBundleUploadedMessage.TYPE,
			MessagesCompressor.encode( message )
		);

		const isEditorBundleUploadedResponse: IsEditorBundleUploadedResponse = MessagesCompressor.decode(
			response,
			IsEditorBundleUploadedResponse
		) as IsEditorBundleUploadedResponse;

		return isEditorBundleUploadedResponse.isUploaded;
	}
}

export default EditorService;
